import UserContext from "hooks/usePageContext";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getIsAuthenticatedStatus,
  getUserDetails,
  validateAuthentication,
  getLoginFailed,
  logout
} from "redux/slices/authenticationSlice";
import LoadingComponent from "components/LoadingComponent";
import { getDashboard } from "redux/slices/dashboardSlice";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import PaymentSetUp from "features/PaymentSetUp";

const WithAuthWrapper = <T extends JSX.IntrinsicAttributes>(
  WrappedComponent: React.ComponentType<T>
): React.FC<T> => {
  const Layout = (props: T) => {
    const isAuthenticated = useSelector(getIsAuthenticatedStatus);
    const user = useSelector(getUserDetails);
    const loginFailed = useSelector(getLoginFailed);
    const accessToken = localStorage.getItem("stmpz-token");
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const dashboard = useSelector(getDashboard);
    const location = useLocation();
    const isNotPaymentPage = !location.pathname.includes("/payment/");
    const isAdmin = user?.email === "info@stmpz.com";
    useEffect(() => {
      // Initialse
      if (!!accessToken) {
        dispatch(validateAuthentication(accessToken));
      } else {
        dispatch(logout());
        navigate("/sign-in");
      }
    }, [accessToken, dispatch, navigate]);

    useEffect(() => {
      // Validation
      if (!!loginFailed) {
        dispatch(logout());
        navigate("/sign-in");
      }
    }, [dispatch, loginFailed, navigate]);

    return (
      <React.Fragment>
        {!isAuthenticated && <LoadingComponent />}
        {Object.keys(dashboard).length > 0 &&
          !dashboard.business.subscription_enabled &&
          !isAdmin && (
            <Modal
              open={
                !dashboard.business.subscription_enabled &&
                isAuthenticated &&
                isNotPaymentPage
              }
            >
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  bgcolor: "background.paper",
                  boxShadow: 24,
                  p: 4,
                  borderRadius: 2,
                  minWidth: 350
                }}
              >
                <PaymentSetUp />
              </Box>
            </Modal>
          )}
        {isAuthenticated && !!accessToken && user && (
          <UserContext.Provider
            value={{
              user: user
            }}
          >
            <WrappedComponent {...props} />
          </UserContext.Provider>
        )}
      </React.Fragment>
    );
  };
  return Layout;
};

export default WithAuthWrapper;
